import { defaultEventProjection } from 'assets/projections';
import './style.less';

export default function($log, $stateParams, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  function activate() {
    $log.debug('Upcoming Invitations Component Activated');
    vm.error = {};
    vm.loaded = false;
    vm.profileUid = $stateParams.id;

    ApiClass.eventsGet(
      { eventType: false, pastEvents: false },
      {},
      {
        queryParams: {
          invitation: true,
          filters: JSON.stringify({
            requireInvitation: true
          }),
          ...defaultEventProjection.reduce((acc, prop) => {
            acc[`projection:${prop}`] = 1;

            return acc;
          }, {})
        }
      }
    )
      .then(({ data: { events } }) => {
        $log.debug('Upcoming Invitations Data:', events);
        vm.invitations = events.filter(({ registration }) => !registration);
        vm.loaded = true;
      })
      .catch(error => {
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        $log.error(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/upcomingInvitations/controller.js